import { SearchInput } from "PFApp/components/search_input";
import ButtonLink from "PFComponents/button/button_link";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { RecentSearchesPageKey } from "PFCore/types/recent_searches";

import css from "../skills_section.module.scss";

type SkillsSectionActionsProps = {
  canEditSkills: boolean;
  searchTerm: string | null;
  onTermChange: (newTerm: string) => void;
};

export const SkillsSectionActions = ({
  canEditSkills,
  searchTerm,
  onTermChange
}: SkillsSectionActionsProps) => (
  <Inline>
    <SearchInput
      term={searchTerm ?? ""}
      pageKey={RecentSearchesPageKey.ProfileSkills}
      onTermChange={onTermChange}
    />
    {canEditSkills && (
      <ButtonLink href="/profiles/me/summary/skills" rootClassName={css.skillsAddButton}>
        <Icon name="add" size="sm" />
      </ButtonLink>
    )}
  </Inline>
);
